import {memo, useEffect} from "react";
import {useFormContext, useWatch, Validate} from "react-hook-form";
import {MissingDocumentationInput} from "../../domain";
import {ModalTextAreaInput} from "../../form-components/ModalTextAreaInput";

type OtherDocumentationsInputProps = {
    sending: boolean;
    validate?: Validate<string> | undefined;
};

const emptyMessage = 'Please tell us what other document(s) are missing';

export const OtherDocumentationsInput = memo((
    {
        sending,
        validate,
    }: OtherDocumentationsInputProps
) => {
    const {getValues, trigger, control} = useFormContext<MissingDocumentationInput>();
    const missingDocumentations = useWatch({
        name: 'missingDocumentations',
        control
    });

    useEffect(() => {
        void trigger('otherDocumentations');
    }, [missingDocumentations, trigger]);

    const getConditionalValidation = () => {
        const missing = getValues('missingDocumentations') ?? '';
        const isRequired = missing.includes('Other');
        return {
            required: {
                value: isRequired,
                message: emptyMessage
            },
            validate: {
                max4000: (v: string) => (v || '').length <= 4000 || 'Maximum length is 4000 characters',
                ...(isRequired ? {notEmpty: (v: string) => (v || '').trim().length > 0 || emptyMessage} : {}),
                ...(validate != null ? {custom: validate} : {})
            }
        };
    };

    return (
        <div className="pr-1">
            <ModalTextAreaInput<MissingDocumentationInput>
                disabled={sending}
                field="otherDocumentations"
                label="Other Documents/Comments"
                placeholder="Enter other documentation or comments..."
                labelPosition="left"
                rowsNum={4}
                maxLength={4000}
                showCharacterCount
                optionalRules={getConditionalValidation()}
            />
        </div>
    );
});
